var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "boxFile", class: { uploading: _vm.loadingUpload } },
    [
      _c("TextInput", {
        attrs: {
          "hide-input": _vm.iValue,
          type: "file",
          label: _vm.label,
          accept: "image/*",
        },
        on: { changed: (file) => _vm.choosedFile(file) },
      }),
      _c(
        "div",
        {
          staticClass: "text-left mb-3",
          style: { marginTop: _vm.iValue ? "-1rem" : 0 },
        },
        [
          _vm.tempImage
            ? _c("img", {
                class: { "full-width": _vm.fullWidth },
                style: { height: "80px" },
                attrs: { src: _vm.tempImage, alt: "" },
              })
            : _vm._e(),
          _vm.iValue
            ? _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger", size: "sm" },
                      on: { click: _vm.deleteFile },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }